import './paedml-card.tag'
import './paedml-modal-delete.tag'
import './paedml-icon-modal.tag'
import './components/paedml-modal-regenerate-sshkey.tag'
import './hub/paedml-modal-hub-host-parameters.tag'
import './hub/paedml-hub-upload-parameter.tag'
import './hub/paedml-modal-update-hub.tag'

<paedml-card-hub>
  <paedml-card config={opts.config} perm={opts.perm} siblings={opts.siblings}>

    <virtual if={isPermitted('hostParams')}>
      <paedml-icon-modal icon="fas-cogs" target="#{prefix}-host-params-modal" title="Host-Parameter bearbeiten" />
      <paedml-modal-hub-host-parameters prefix="{prefix}-host-params"
        heading="{config.contentTitle}: Host-Parameter bearbeiten" opname="Host-Parameter bearbeiten" api={restApi} />
    </virtual>

    <virtual if={isPermitted('ssh')}>
      <paedml-icon-modal icon="passwort-bearbeiten" target="#{prefix}-regenerate-sshkey-modal" title="SSH Schlüssel neu erstellen" />
      <paedml-modal-regenerate-sshkey prefix="{prefix}-regenerate-sshkey"
        heading="{config.contentTitle}: SSH-Schlüssel erstellen" opname="SSH-Schlüssel neu erstellen" api={restApi}
        patient="paed.ML Hub"
      />
    </virtual>

    <virtual if={isPermitted('upload')}>
      <paedml-icon-modal icon="fas-file-upload" target="#{prefix}-upload-parameters-modal" title="Parameter und Host-Parameter hochladen" />
      <paedml-hub-upload-parameter prefix="{prefix}-upload-parameters"
        heading="{config.contentTitle}: Parameter und Host-Parameter hochladen" opname="Parameter und Host-Parameter hochladen" api={restApi}
      />
    </virtual>

    <virtual if={isPermitted('upload')}>
      <paedml-icon-modal icon="fas-upload" target="#{prefix}-update-hub-modal" title="paed.ML Hub Systemupdate" />
      <paedml-modal-update-hub prefix="{prefix}-update-hub" selectedrowsfunc={getSelectedRows}
        heading="{config.contentTitle}: paed.ML Hub Systemupdate" opname="Update starten" api={restApi}
      />
    </virtual>

  </paedml-card>

</paedml-card-hub>
